import app from "@/main";
import {UyapRequest} from "./UyapRequest";
import {ISorguSonuc} from "./CommonInterfaces";

export interface DosyaBorcluBagkurTalep {
    dosyaId: string | number,
    kisiKurumId: number,
    sorguBakiye: number | string,
}

export interface DosyaBorcluBagkurCevap extends ISorguSonuc<IBorcluBagkurSonuc> {
}

// DEV-3354: UYAP 4/b cevabı yeni şemaya geçti. Kayıtlar üst seviyedeki tescilKaydi4BList yerine
// tescilKaydi4b.tesciller altında geliyor; anaHataKodu/anaHataMesaji yerine hataKodu/hataMesaji var.
export interface IBorcluBagkurSonuc {
    hataKodu: number,
    hataMesaji: string,
    tescilKaydi4b: ITescilKaydi4B
}

export interface ITescilKaydi4B {
    islemSonuc: number,
    islemSonucAciklama: string,
    tesciller?: Array<ITescil4B>
}

export interface ITescil4B {
    ad: string,
    adres: string,
    bagNo: string,
    cilt: string,
    cinsiyet: string,
    dogumTarihi: number,
    dogumYeri: string,
    emeklilikKodu: string | null,
    hane: string,
    meslekIlce: string,
    meslekili: number,          // eski: meslekiIi
    nufusIlce: string,
    nufusili: number,           // eski: nufusIli
    sira: string,
    soyad: string,
    terkAciklama: string,
    terkKodu: number,
    terkTarihi: number,
    tescilTarihi: number,
    vatandasNo: string,         // eski: tcKimlikNo
    tescilTerkler: Array<ITescilTerk>   // eski: tescilTerklerList
}

export interface ITescilTerk {
    kodu: number,
    terkTarihi: number
}

// Güncellenme Tarihi: 21/01/2026

export default class DosyaBorcluBagkur extends UyapRequest<DosyaBorcluBagkurTalep, DosyaBorcluBagkurCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Dosya borçlu Bağkur bilgileri sorgulanıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "dosyaBorcluBagkur_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"tcKimlikNo":"4********10","adi":"AH**** MÜ***","soyadi":"YA*******","babaAdi":"A*********","anaAdi":"Ş*****","dogumTarihiStr":"1957","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":28698317,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 2. Genel İcra Dairesi","birimId":"1000963","orgKodu":"1.04.011.000.6037","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6037","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/27440","dosyaNoYil":2023,"dosyaSira":27440,"dosyaId":"013@RlwAzAkR3QHUdOJ2Imv3xfm5YKyfVue9qZ9EtSkx4CDcffzLTi+1keD52oCJ","dosyaAcilisTarihi":"08/07/2023 10:35","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"ABDULSELAM DENİZ, AHMETİ MÜNÜR YALÇINALP","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"25/04/2024 11:53","sorguSonucDVO":{"hataKodu":0,"hataMesaji":"Kayıt bulundu.","tescilKaydi4b":{"islemSonuc":0,"islemSonucAciklama":"Kayıt bulundu.","tesciller":[{"ad":"AHMETİ MÜNÜR","adres":"İVEDİK CADDE LEVENT APT NO:153/4 DEMETEVLER ANKARA","bagNo":"1173483581","cilt":"28","cinsiyet":"E","dogumTarihi":19570825,"dogumYeri":"SİVAS","emeklilikKodu":"2","hane":"189","meslekIlce":"08","meslekili":6,"nufusIlce":"0","nufusili":58,"sira":"28","soyad":"YALÇINALP","terkAciklama":"#07-Yaşlılık Ayl.Talebi","terkKodu":7,"terkTarihi":20190826,"tescilTarihi":20030901,"vatandasNo":"47161224210","tescilTerkler":[{"kodu":0,"terkTarihi":20030901},{"kodu":7,"terkTarihi":20190826}],"isNew":true}],"isNew":true},"isNew":true},"sorgulamaTuru":"Bağkur Çalışanı","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false}
        // olmama durumu
        // return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","yabanci":false,"mavikart":false,"sorguTuru":0,"tcKimlikNo":"4********62","adi":"CU**","soyadi":"EV***","babaAdi":"V***","anaAdi":"D****","dogumTarihiStr":"1956","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":4000031592,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 1. Genel İcra Dairesi","birimId":"1000967","orgKodu":"1.04.011.000.6036","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6036","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2011/16108","dosyaNoYil":2011,"dosyaSira":16108,"dosyaId":"1iBIjYlKrVsTq1wUgjx2RSSdn6JvZmYuaZHinPunLERzhAK4c2hxPxFnW3tlMevW","dosyaAcilisTarihi":"16/12/2011 10:18","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"CUMA EVCİL","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false},"sorguTarihi":"21/01/2026 13:01","sorguSonucDVO":{"hataKodu":1,"hataMesaji":"Kayıt bulunamadı.","tescilKaydi4b":{"islemSonuc":1,"islemSonucAciklama":"Kayıt bulunamadı.","isNew":true},"isNew":true},"sorgulamaTuru":"Bağkur Çalışanı","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_sgk_bagkurCalisaniBilgileri.ajx';
    }

    async parse(data: any): Promise<DosyaBorcluBagkurCevap> {
        // DEV-3354: kimlik bilgisi eksikse UYAP cevap yerine düz hata metni, kayıt yoksa
        // sorguSonucDVO'yu hiç döndürmüyor; açıklama da artık tescilKaydi4b altında.
        const sonuc = data.sorguSonucDVO;
        if (typeof sonuc === "string" && sonuc)
            data.message = sonuc;
        else
            data.message = sonuc?.tescilKaydi4b?.islemSonucAciklama
                || sonuc?.hataMesaji
                || "Bağ-Kur kaydı bulunamadı";
        return data;
    }

}


